
export const locale = {
  lang: "en",
  data: {
    "Logout": "Logout",
  }
};
